<template>
	<div>
		<!-- Create a button that your customers click to complete their purchase. Customize the styling to suit your branding. -->
		<button
		  style="background-color:#6772E5;color:#FFF;padding:8px 12px;border:0;border-radius:4px;font-size:1em"
		  id="checkout-button-plan_FzFpcygEoFHnos"
		  role="link"
		  v-on:click="subscribe($event)"
		>
		  Checkout
		</button>
		<div id="error-message"></div>
	</div>
</template>
<script>

export default {
  name: 'Subscribe', 
  data () {
    return {}
  },
  methods: {
  	subscribe: function(event) {
  		console.log("Clicked!")
  		var stripe = Stripe('pk_test_ge8oNhtTymS2X4sKNySY8mc500xZBauV8I');
  		stripe.redirectToCheckout({
			items: [{plan: 'plan_FzFpcygEoFHnos', quantity: 1}],

			// Do not rely on the redirect to the successUrl for fulfilling
			// purchases, customers may not always reach the success_url after
			// a successful payment.
			// Instead use one of the strategies described in
			// https://stripe.com/docs/payments/checkout/fulfillment
			successUrl: 'http://localhost:8080/#/success',
			cancelUrl: 'http://localhost:8080/#/cancel',
		})
		.then(function (result) {
			if (result.error) {
			// If `redirectToCheckout` fails due to a browser or network
			// error, display the localized error message to your customer.
			var displayError = document.getElementById('error-message');
			displayError.textContent = result.error.message;
		}
		});
  	}
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Subscribe.vue